/**
 * @packageDocumentation
 * @module HackerAPI.Email.Trigger.Record
 */
/**
 * The possible record types
 * @enum
 */
var Record = /** @class */ (function () {
    function Record() {
    }
    Object.defineProperty(Record, "EVENT", {
        /**
         * @returns
         */
        get: function () {
            return "event";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record, "PIPELINE", {
        /**
         * @returns
         */
        get: function () {
            return "pipeline";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record, "CLAIM", {
        /**
         * @returns
         */
        get: function () {
            return "claim";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record, "FILE", {
        /**
         * @returns
         */
        get: function () {
            return "file";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Record, "USER", {
        /**
         * @returns
         */
        get: function () {
            return "user";
        },
        enumerable: true,
        configurable: true
    });
    return Record;
}());
export default Record;
//# sourceMappingURL=record.js.map